<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="toc">
<p class="ct">Contents</p>
<p class="tocfm"><a class="xref" href="#/pppdealdie0004#ded">Dedication</a></p>
<p class="tocfm"><a class="xref" href="#/pppdealdie0006#acknow">Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0007#ch01">Chapter 1</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0008#ch02">Chapter 2</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0009#ch03">Chapter 3</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0010#ch04">Chapter 4</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0011#ch05">Chapter 5</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0012#ch06">Chapter 6</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0013#ch07">Chapter 7</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0014#ch08">Chapter 8</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0015#ch09">Chapter 9</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0016#ch10">Chapter 10</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0017#ch11">Chapter 11</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0018#ch12">Chapter 12</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0019#ch13">Chapter 13</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0020#ch14">Chapter 14</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0021#ch15">Chapter 15</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0022#ch16">Chapter 16</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0023#ch17">Chapter 17</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0024#ch18">Chapter 18</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0025#ch19">Chapter 19</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0026#ch20">Chapter 20</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0027#ch21">Chapter 21</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0028#ch22">Chapter 22</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0029#ch23">Chapter 23</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0030#ch24">Chapter 24</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0031#ch25">Chapter 25</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0032#ch26">Chapter 26</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0033#ch27">Chapter 27</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0034#ch28">Chapter 28</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0035#ch29">Chapter 29</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0036#ch30">Chapter 30</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0037#ch31">Chapter 31</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0038#ch32">Chapter 32</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0039#ch33">Chapter 33</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0040#ch34">Chapter 34</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0041#ch35">Chapter 35</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0042#ch36">Chapter 36</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0043#ch37">Chapter 37</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0044#ch38">Chapter 38</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0045#ch39">Chapter 39</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0046#ch40">Chapter 40</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0047#ch41">Chapter 41</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0048#ch42">Chapter 42</a></p>
<p class="toc"><a class="xref" href="#/pppdealdie0049#ch43">Chapter 43</a></p>
<p class="tocbm"><a class="xref" href="#/pppdealdie0050#authnote">Author’s Note</a></p>
<p class="tocbm"><a class="xref" href="#/pppdealdie0051#moreauth">More from this Author</a></p>
<p class="tocbm"><a class="xref" href="#/pppdealdie0052#contactus">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-dealdie0005.vue?c815862a